module.exports = __webpack_public_path__ + "img/de.7f899b40.svg";